import React from "react";
import ApiUrl from "./ApiUrl";

export const LoginService = (data) => {
   // login
   const service = `${ApiUrl}user/login`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ProfileService = () => {
   // perfil de usuario de la sesión
   const service = `${ApiUrl}user/profile`;
   const data = {token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const UpdateUserService = (dat) => {
   // perfil de usuario de la sesión
   const service = `http://domecqapi.trebolbit.com/api/user/update`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const ListUserService = () => {
   // lista de todos los usuarios
   const service = `${ApiUrl}user/comunity_list`;
   const data = {idRol: 0, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListaDeUsuarios = () => {
   // lista de todos los usuarios
   const service = `${ApiUrl}user/list_users`;
   return fetch(service);
};
export const ListAdminService = () => {
   // lista de todos los usuarios
   const service = `${ApiUrl}user/admin_list`;
   const data = {token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const DeactivateUser = (dat) => {
   // desactivar a un usuaro
   const service = `${ApiUrl}user/disable_user`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const ForgotPasswordService = (data) => {
   // desactivar a un usuaro
   const service = `${ApiUrl}user/disable_user`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
